import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GardenResponse, TabDetail } from './logo-garden.interfaces';
import { LogoGardenService } from '../../services/logo-garden.service';

@Component({
  selector: 'logo-garden',
  templateUrl: './logo-garden.component.html',
  styleUrls: ['./logo-garden.component.scss']
})
export class LogoGardenComponent implements OnInit {
  gardenData: GardenResponse['result'];
  activeTabId: number;
  // hasValidGardenData: boolean = false;

  constructor(
    private translateService: TranslateService,
    private logoGardenService: LogoGardenService
  ) {}

  ngOnInit() {
    // this.logoGardenService.getGardenData().subscribe({
    //   next: (data) => {
    //     this.gardenData = data.result;
    //     this.activeTabId = this.gardenData.tabs[0]?.tabId;
    //     this.hasValidGardenData = true;
    //   },
    //   error: () => {
    //     this.hasValidGardenData = false;
    //   }
    // });

    this.logoGardenService.getGardenData().subscribe(data => {
      this.gardenData = data.result;
      this.activeTabId = this.gardenData.tabs[0]?.tabId;
    });
  }

  getTabDetails(tabId: number): TabDetail[] {
    return this.gardenData?.tabDetails[tabId.toString()] || [];
  }

  shouldShowOtherPartners(tabId: number): boolean {
    return this.getTabDetails(tabId).some(detail => !detail.showLogo);
  }

  getLogoPartners(tabId: number): TabDetail[] {
    return this.getTabDetails(tabId).filter(detail => detail.showLogo);
  }

  getOtherPartners(tabId: number): TabDetail[] {
    return this.getTabDetails(tabId).filter(detail => !detail.showLogo);
  }
} 